// UserInfoToolMenu.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'; // 사용자 삭제.
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'; // 정보취급자로 변경
import GppBadIcon from '@mui/icons-material/GppBad'; // 정보취급자 해제
import NoAccountsIcon from '@mui/icons-material/NoAccounts'; // 사용중지.
import AccountCircleIcon from '@mui/icons-material/AccountCircle'; // 사용중지 해제
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { useAuthorizationCheck } from '../../api/app-hook';
import { AppObject, AppStyle } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';

// for modal background
const ToolMenuBackground = styled(Box)({
    position: 'fixed', top: 0, right: 0, bottom: 0, left: 0,
    backgroundColor: 'rgba(0,0,0,0.01)',
});
const ToolMenu = styled(Box)({
    position:'absolute', right:30,
    backgroundColor: '#ccc',
    border: AppStyle.PrimaryRGB,
    borderRadius: 4,
    padding: 5,
});

const UserTitle = styled(Box)({
    textAlign: 'center',
    color: AppStyle.PrimaryRGB,
    padding: '10px 10px',
    borderBottom: AppStyle.BorderCCC, borderRadius: 4,
    backgroundColor: '#eee'
});

export const UserInfoToolCmd = {
    Use: 'use',
    NoUse: 'nouse',
    Handler: 'handler',
    NoHandler: 'nohandler',
}

export default function UserInfoToolMenu({
    item,
    onClose,
    position, // tool menu click event
    onClickTool,
}) {
    const [tools, setTools] = useState([]);
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const authChecker = useAuthorizationCheck();

    useEffect(()=>{
        if(item && authTableTree) {
            const canEdit = authChecker(authTableTree.tree.pr_user_info_edit);
            const canRemove = authChecker(authTableTree.tree.pr_user_info_remove);
            const canSetUsage = authChecker(authTableTree.tree.pr_user_info_set_usage);
            const canSetHanler = authChecker(authTableTree.tree.pr_user_info_set_secu_handler);

            const toolList = [];
            if(canEdit) toolList.push({id:AppObject.command.EDIT, icon:<EditIcon/>, color: AppStyle.mui.primary, label:'사용자 정보 수정'});
            if(canSetUsage) {
                if(item.useYn==='Y') toolList.push({id:UserInfoToolCmd.NoUse, icon:<NoAccountsIcon/>, color: AppStyle.mui.secondary, label:'사용중지'});
                else toolList.push({id:UserInfoToolCmd.Use, icon:<AccountCircleIcon/>, color: AppStyle.mui.success, label:'사용중지 해제'});
            }
            if(canSetHanler && item.useYn==='Y' && ValueMisc.isDcClassId(item.authClassId)) {
                if(item.handlerYn==='Y') toolList.push({id:UserInfoToolCmd.NoHandler, icon:<GppBadIcon/>, color: AppStyle.mui.success, label:'정보취급자 해제'});
                else toolList.push({id:UserInfoToolCmd.Handler, icon:<HealthAndSafetyIcon/>, color: AppStyle.mui.info, label:'정보취급자 지정'});
            }
            if(canRemove) toolList.push({id:AppObject.command.DELETE, icon:<PersonRemoveIcon/>, color: AppStyle.mui.warning, label:'사용자 정보 삭제'});

            setTools(toolList);
        }

    }, [item, authChecker, authTableTree]);

    const toolTop = position.clientY - tools.length * 40 - 40;

    return (
        <ToolMenuBackground onClick={onClose}>
            <ToolMenu style={{top:toolTop}}>
                <UserTitle>{item.userName}</UserTitle>
                {
                    tools.map((tool, idx) => {
                        return(
                            <Box key={idx}
                            >
                                <Button
                                    onClick={()=>onClickTool(tool.id)}
                                    key={idx}
                                    variant={AppStyle.mui.contained}
                                    color={tool.color}
                                    startIcon={tool.icon}
                                    sx={{width: 200}}
                                    fullWidth
                                >
                                    {tool.label}
                                </Button>
                            </Box>
                        )
                    })
                }
            </ToolMenu>
        </ToolMenuBackground>
    );
}
